import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { prepareValidationForDirectus } from './common/common_utils';
import { filterCollections } from './common/common_utils';
import { DIRECTUS } from 'drapcode-constant';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentCardNoHeader from '../common/ParentCardNoHeader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class DirectusDatasource extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSendRequset = async (values) => {
    const { baseUrl, dataSourceName, userToken } = values;
    const { actions, match, history } = this.props;
    const { projectId, version } = match.params;
    await actions.getCollectionsForDirectus({ projectId, version, baseUrl, userToken });

    if (this.props.dataConnector.collectionByDirectus) {
      const collections = this.props.dataConnector.collectionByDirectus;
      const collectionNames = filterCollections(collections);
      const { baseUrl, dataSourceName, userToken } = values;

      const { actions, match, history } = this.props;
      const { projectId, version } = match.params;
      const setting = {
        baseUrl,
        Authorization: `Bearer ${userToken}`,
      };

      const dataForSave = {
        name: dataSourceName,
        projectVersion: version,
        projectId,
        type: DIRECTUS,
        setting,
        completeData: {
          tables: collectionNames,
        },
      };
      await actions.saveExternaldatabaseForDirectus(dataForSave);
      const { externalDbUuid } = this.props.dataConnector;
      await actions.supabaseEnvironmentVariables({
        dataForSave,
        projectId,
        version,
        externalDatabaseId: externalDbUuid,
      });
      if (externalDbUuid) {
        history.push(
          `/2.0/data-connector/${version}/v/${projectId}/directus-datasource/${externalDbUuid}`,
        );
      }
    }
  };
  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/2.0/collections/${version}/v/${projectId}/create`);
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { getCollectionsForDirectusPending, saveExternaldatabaseForDirectusPending } =
      this.props.dataConnector;
    return (
      <CommonPageComponent>
        <ParentContentCard title="Create Collection via Directus" datasourceIconSvg="Directus">
          <Formik
            initialValues={{
              dataSourceName: '',
              userToken: '',
              baseUrl: '',
            }}
            validationSchema={prepareValidationForDirectus}
            onSubmit={this.handleSendRequset}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter name for the Data Source you want to create in drapcode.'
                    }
                  >
                    <Field
                      type="text"
                      name="dataSourceName"
                      className="form-control form-control-sm"
                      placeholder="Data Source Name"
                    />
                    <ErrorMessage name="dataSourceName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <ParentCardNoHeader title="Directus Account Details">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Base URL"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Your Base Url. It acts as the endpoint for accessing and managing your database resources.'
                      }
                    >
                      <Field
                        type="text"
                        name="baseUrl"
                        className="form-control form-control-sm"
                        placeholder="BaseUrl eg.https://directus.drapcode.us"
                      />
                      <ErrorMessage name="baseUrl" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="User Token"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Directus Token from your Directus Settings section. This Token is necessary for your application to interact with the Directus backend services. Never share it publicly.'
                      }
                    >
                      <Field
                        type="text"
                        name="userToken"
                        className="form-control form-control-sm"
                        placeholder="User Token"
                      />
                      <ErrorMessage name="userToken" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                </ParentCardNoHeader>

                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={
                      isSubmitting ||
                      getCollectionsForDirectusPending ||
                      saveExternaldatabaseForDirectusPending
                    }
                  >
                    <i className="wb webconnect-rocket"></i> &nbsp;Continue&nbsp;
                    <CustomLoader
                      loading={
                        getCollectionsForDirectusPending || saveExternaldatabaseForDirectusPending
                      }
                    ></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectusDatasource);
